import { Component, OnInit, ViewChild, Inject } from '@angular/core';
import { MatDialogRef, MatTableDataSource, MatSort, MAT_DIALOG_DATA, MatDialog } from '@angular/material';
import { ActivatedRoute } from '@angular/router';
import { Router } from '@angular/router';

import { ApplicationConstants } from '../../providers/application-constants';
import { Utils } from '../../providers/utils';
import { QueryList } from '../../providers/query-list';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-journal-entry',
  templateUrl: './journal-entry.component.html',
  styleUrls: ['./journal-entry.component.css']
})
export class JournalEntryComponent implements OnInit {

  line_count = 0;
  total_debit = 0;
  total_credit = 0;

  displayedColumns = ['chx_del', 'entry_desc', 'acct_name', 'debit_amount', 'credit_amount', 'currency_id',
    'cost_center'];

  count = 1;
  private dp = [{
    'id': this.count, 'entry_desc': '', 'acct_name': '', 'acct_number': '', 'credit_amount': '',
    'debit_amount': '', 'currency_id': '1', 'cost_center': '0', 'entry_id': '', 'flag': 'new'
  }];
  dataSource = new MatTableDataSource(this.dp);
  @ViewChild(MatSort) sort: MatSort;

  search_obj = {
    'placeholder': 'رقم الحساب/ اسم الحساب', 'class_name': 'longSearchField',
    'table_list': [
      {
        'table_name': '`sub_acct`', 'selected_no': 'acct_number',
        'field_list': ['acct_number', 'sub_acct_name', 'sub_acct_name_en'],
        'condition': " AND `sub_acct`.`is_leaf` = '1' AND `sub_acct`.`is_cc` = '1'"
      }
    ]
  };

  currencyList = [];
  costCenterList = [];
  model = {
    'table_name': 'journal_entry', 'entry_no': '0', 'entry_date_d': new Date(), 'entry_date': '1970-01-01',
    'acct_number': '0', 'acct_name': '', 'debit_amount': '0', 'credit_amount': '0', 'currency_id': '0', 
    'entry_desc': '', 'branch_id': this.applicationConstants.user_branch_info.user_branch_id, 'comment': '', 
    'no':'0', 'year': ''
  };

  toDelete = [];
  toUpdate = [];
  no = '';

  Success_Msg; Error_Msg; Acct_Placeholder; Select_Acct_Msg;
  Define_Cr_De_Msg; Credit_Debit_Msg; Del_Line_Msg; Entry_No;

  constructor(private utils: Utils, private applicationConstants: ApplicationConstants,
    private queryList: QueryList, private router: Router, private route: ActivatedRoute, public translate: TranslateService) {
    this.getMessages(translate);
  }

  getMessages(translate) {

    translate.setDefaultLang(this.applicationConstants.user_lang);
    translate.use(this.applicationConstants.user_lang);

    translate.get('Acct_Placeholder').subscribe((res: string) => {
      this.Acct_Placeholder = res;
    });
    this.search_obj['placeholder'] = this.Acct_Placeholder;

    translate.get('Success_Msg').subscribe((res: string) => {
      this.Success_Msg = res;
    });

    translate.get('Error_Msg').subscribe((res: string) => {
      this.Error_Msg = res;
    });

    translate.get('Select_Acct_Msg').subscribe((res: string) => {
      this.Select_Acct_Msg = res;
    });

    translate.get('Define_Cr_De_Msg').subscribe((res: string) => {
      this.Define_Cr_De_Msg = res;
    });

    translate.get('Credit_Debit_Msg').subscribe((res: string) => {
      this.Credit_Debit_Msg = res;
    });

    translate.get('Del_Line_Msg').subscribe((res: string) => {
      this.Del_Line_Msg = res;
    });

    translate.get('Entry_No').subscribe((res: string) => {
      this.Entry_No = res;
    });
  }


  ngOnInit() {
    this.toDelete = [];
    this.toUpdate = [];
    let query = this.queryList.all_currency;
    let obj = { cmd: 'getList', query: query };

    this.utils.invokeHttp(this.applicationConstants.generalFile, obj)
      .subscribe(data => {
        this.applicationConstants.appComp.hideBusyCursor();
        this.currencyList = data.data['list'];
      });

    query = this.queryList.all_costCenter;
    obj = { cmd: 'getList', query: query };
    this.utils.invokeHttp(this.applicationConstants.generalFile, obj)
      .subscribe(data => {
        this.applicationConstants.appComp.hideBusyCursor();
        this.costCenterList = data.data['list'];

        let costObj = { 'cc_id': '0', 'cc_number': '0', 'cc_name': 'الرئيسي', 'cc_name_en': 'Main' };
        this.costCenterList.unshift(costObj);
      });

    this.route.params.subscribe(params => {
      if (params['no'] != undefined) {
        this.no = params['no'];

        this.dp = [];
        this.dataSource = new MatTableDataSource(this.dp);
        this.dataSource.sort = this.sort;

        query = "SELECT * FROM `journal_entry` WHERE `entry_no` = '" + this.no + "' AND `status` = 1 ";
        obj = { cmd: 'getList', query: query };

        this.utils.invokeHttp(this.applicationConstants.generalFile, obj)
          .subscribe(data => {
            this.applicationConstants.appComp.hideBusyCursor();
            let result = data.data['list'];
            this.count = 1;
            this.line_count = result.length;
            this.total_debit = 0;
            this.total_credit = 0;

            result.forEach(element => {
              if (this.count == 1) {
                this.model['no'] = element.no;
                this.model['year'] = element.year;
                this.model['entry_no'] = element.entry_no;
                this.model['entry_date_d'] = new Date(element.entry_date);
                this.model['entry_date'] = element.entry_date;
                this.model['comment'] = element.comment;
                this.model['branch_id'] = element.branch_id;
              }

              this.dp.push({
                'id': this.count, 'entry_desc': element.entry_desc, 'acct_name': element.acct_name,
                'acct_number': element.acct_number, 'credit_amount': element.credit_amount,
                'debit_amount': element.debit_amount, 'currency_id': element.currency_id, 
                'cost_center': element.cost_center, 'entry_id': element.entry_id, 'flag': 'none'
              });

              this.total_credit += Number(element.credit_amount);
              this.total_debit += Number(element.debit_amount);
              this.count++;
            });

            this.dataSource = new MatTableDataSource(this.dp);
            this.dataSource.sort = this.sort;
          });
      }
    });
  }

  onChangeSearch = function (search_result: object) {
    (document.getElementById('acct_number_' + search_result['row_id']) as HTMLInputElement).value = search_result['no'];
    
    let entry_id = document.getElementById('entry_id_' + search_result['row_id']) as HTMLInputElement;
    let flag = document.getElementById('flag_' + search_result['row_id']) as HTMLInputElement;
    
    // if the mode is edit and the record already there and need to be updated
    if (entry_id.value != '' && entry_id.value != '0') {
      if (flag.value == "none")
        (document.getElementById('flag_' + search_result['row_id']) as HTMLInputElement).value = 'update';
    }
  }

  addLine() {
    this.count++;
    this.dp.push({
      'id': this.count, 'entry_desc': '', 'acct_name': '', 'acct_number': '', 'credit_amount': '',
      'debit_amount': '', 'currency_id': '1', 'cost_center': '0', 'entry_id': '', 'flag': 'new'
    });
    this.dataSource = new MatTableDataSource(this.dp);
    this.dataSource.sort = this.sort;
  }

  delLine() {
    let count = 0;
    for (let index = (this.dp.length - 1); index >= 0; index--) {
      let id = this.dp[index]['id'];

      let check = document.getElementById('chx_del_' + id) as HTMLInputElement;
      let debit_amount = document.getElementById('debit_amount_' + id) as HTMLInputElement;
      let credit_amount = document.getElementById('credit_amount_' + id) as HTMLInputElement;
      let entry_id = document.getElementById('entry_id_' + id) as HTMLInputElement;

      if (check.checked == true) {
        // check if saved record deleted 
        //if the mode is edit and the record already there and need to be deleted 
        if (entry_id.value != '' && entry_id.value != '0') {
          this.toDelete.push(this.dp[index]);
        }

        if (debit_amount.value != '' || credit_amount.value != '')
          this.line_count--;

        if (debit_amount.value != '')
          this.total_debit -= Number(debit_amount.value);
        else if (credit_amount.value != '')
          this.total_credit -= Number(credit_amount.value);

        this.total_debit = Number(this.total_debit.toFixed(2));
        this.total_credit = Number(this.total_credit.toFixed(2));
        
        this.dp.splice(index, 1);
        this.dataSource = new MatTableDataSource(this.dp);
        this.dataSource.sort = this.sort;
        count++;
      }
    }
    
    if (count == 0)
      alert(this.Del_Line_Msg);
  }

  changeAmount(type, row_id) {

    if (type == 'debit') {
      let credit_amount = document.getElementById('credit_amount_' + row_id) as HTMLInputElement;
      credit_amount.value = '';
    }
    else if (type == 'credit') {
      let debit_amount = document.getElementById('debit_amount_' + row_id) as HTMLInputElement;
      debit_amount.value = '';
    }
    this.line_count = 0;
    this.total_debit = 0;
    this.total_credit = 0;

    this.dp.forEach(element => {
      let id = element['id'];
      let debit_amount = document.getElementById('debit_amount_' + id) as HTMLInputElement;
      let credit_amount = document.getElementById('credit_amount_' + id) as HTMLInputElement;

      if (debit_amount.value != '' || credit_amount.value != '')
        this.line_count++;

      if (Number(debit_amount.value) != 0)
        this.total_debit += Number(debit_amount.value);
      else if (Number(credit_amount.value) != 0)
        this.total_credit += Number(credit_amount.value);

      this.total_debit = Number(this.total_debit.toFixed(2));
      this.total_credit = Number(this.total_credit.toFixed(2));

    });
    let flag = document.getElementById('flag_' + row_id) as HTMLInputElement;
    //if the mode is edit and the record already there and need to be updated
  
    if (flag.value == "none")
      (document.getElementById('flag_' + row_id) as HTMLInputElement).value = 'update';
  }

  changeInput(row_id) {
    let flag = document.getElementById('flag_' + row_id) as HTMLInputElement;
    if (flag.value == "none")
      (document.getElementById('flag_' + row_id) as HTMLInputElement).value = 'update';
  }

  add() {

    if (this.total_debit == this.total_credit) {
      let error = '';
      let values = [];
      let year;

      this.model['entry_date'] = (this.model['entry_date_d'].getFullYear() + '-' +
        (this.model['entry_date_d'].getMonth() + 1) + '-' + this.model['entry_date_d'].getDate() + ' ' +
        new Date().getHours() + ':' + new Date().getMinutes() + ':' + new Date().getSeconds());
      // console.log(this.model['entry_date']); 

      if (this.no == '') {
        year = this.model['entry_date_d'].getFullYear();
        this.model['year'] = String(year);
      }

      this.dp.forEach(element => {
        let id = element['id'];
        let entry_id = document.getElementById('entry_id_' + id) as HTMLInputElement;
        
        if (entry_id.value == '')
          entry_id.value = '0';
        let entry_desc = document.getElementById('entry_desc_' + id) as HTMLInputElement;
        let acct_number = document.getElementById('acct_number_' + id) as HTMLInputElement;
        let acct_name = document.getElementById('search_value_' + id) as HTMLInputElement;
        let debit_amount = document.getElementById('debit_amount_' + id) as HTMLInputElement;
        let credit_amount = document.getElementById('credit_amount_' + id) as HTMLInputElement;
        let currency_id = document.getElementById('currency_id_' + id) as HTMLInputElement;
        let cost_center = document.getElementById('cost_center_' + id) as HTMLInputElement;
        let flag = document.getElementById('flag_' + id) as HTMLInputElement;

        if (error == '' && acct_number.value != '' && (Number(debit_amount.value) != 0 || Number(credit_amount.value) != 0)) {
          values.push({
            'table_name': this.model['table_name'], 'entry_id': entry_id.value, 'no': this.model['no'], 
            'year': this.model['year'], 'entry_no': (this.no != null ? this.no : ''), 'key': 'entry_id',
            'entry_date': this.model['entry_date'], 'acct_number': acct_number.value, 'acct_name': acct_name.value,
            'debit_amount': (debit_amount.value != '' ? debit_amount.value : '0'), 'flag': flag.value,
            'credit_amount': (credit_amount.value != '' ? credit_amount.value : '0'), 'currency_id': currency_id.value,
            'cost_center': cost_center.value, 'entry_desc': entry_desc.value, 'comment': this.model['comment'], 
            'branch_id': this.model['branch_id']
          });

          // if (flag.value == "new")
          //   values[values.length -1]['branch_id'] = this.applicationConstants.user_branch_info.user_branch_id;
        }
        else {
          if (acct_number.value == '')
            error = this.Select_Acct_Msg + id;
          else if (debit_amount.value == '' && credit_amount.value == '')
            error = this.Define_Cr_De_Msg + id;
        }
      });
      
      if (error == '') {
        let obj;
       
        if (this.no != "") {
          this.toDelete.forEach(delElem => {
            values.push({
              'table_name': this.model['table_name'], 'entry_id': delElem.entry_id, 'key': 'entry_id',
              'entry_no': (this.no != null ? this.no : ''), 'flag': 'delete'
            });
          });

          obj = { cmd: 'updateAdv', values: values };
        }
        else {
           // to add the new numbering method [START]
          let idWhere = " WHERE `year` = '" + year + "' AND `branch_id` = '" + this.model['branch_id'] + "'";
          let prefix = this.model['branch_id'] + '-' + year + '-';
          console.log(idWhere);
          // [END]

          obj = { cmd: 'add', values: values, pk: 'entry_no', id: 'no', main_table: 'journal_entry', 
            prefix: prefix, idWhere: idWhere };
        }

        this.utils.invokeHttp(this.applicationConstants.generalFile, obj)
          .subscribe(data => {
            this.applicationConstants.appComp.hideBusyCursor();
            if (data.status['type'] == 'success') {
              
              let entry_no = this.no;
              if (this.no == '')
                entry_no = data.status['msg'][0]['number'];

              alert(this.Success_Msg + ', ' + this.Entry_No + ": " + entry_no);
              window.open(this.applicationConstants.generatePDF + "?entry_no=" + entry_no, "_blank");
              this.router.navigate(['sub_menu/3/journal_entry_list']);
            }
            else if (data.status['type'] != 'success') {
              alert(this.Error_Msg);
            }
          });
      }
      else
        alert(error);
    }
    else
      alert(this.Credit_Debit_Msg);
  }

  // toUpdateArr: is the array to check in, item: the item that will be checked its availability, 
  //key: the key that will be checked as an id
  addToArrUpdate(row_id, key, key_value)//:Array<Object>
  {
    //let exist = false;
    //let itmToUpdate;
    for (let i = 0; i < this.toUpdate.length; i++) {
      let itm = this.toUpdate[i];
      if (itm[key] == key_value) {
        this.toUpdate.splice(i, 1);
        i--;
      }
    }
    
    let entry_desc = document.getElementById('entry_desc_' + row_id) as HTMLInputElement;
    let acct_number = document.getElementById('acct_number_' + row_id) as HTMLInputElement;
    let acct_name = document.getElementById('search_value_' + row_id) as HTMLInputElement;
    let debit_amount = document.getElementById('debit_amount_' + row_id) as HTMLInputElement;
    let credit_amount = document.getElementById('credit_amount_' + row_id) as HTMLInputElement;
    let currency_id = document.getElementById('currency_id_' + row_id) as HTMLInputElement;
    let cost_center = document.getElementById('cost_center_' + row_id) as HTMLInputElement;
    this.toUpdate.push({
      'table_name': this.model['table_name'], 'key': key, 'entry_id': key_value,
      'entry_date': this.model['entry_date'], 'acct_number': acct_number.value, 'acct_name': acct_name.value,
      'debit_amount': (debit_amount.value != '' ? debit_amount.value : '0'),
      'credit_amount': (credit_amount.value != '' ? credit_amount.value : '0'), 'currency_id': currency_id.value,
      'cost_center': cost_center.value, 'entry_desc': entry_desc.value, 'comment': this.model['comment']
    });

  }

  changeHeader() { // (input)="changeHeader()" for html 

    if (this.no != '') {
      //this.toUpdate.push({'table_name':this.model['table_name'], 'key':'entry_no', 'entry_no':this.no, 
      //  'entry_date':this.model['entry_date'], 'comment':this.model['comment']});
      this.dp.forEach(element => {
        //let id = element['id'];
        //let entry_id = document.getElementById('entry_id_' + id) as HTMLInputElement;
        if (element['flag'] == "none")
          element['flag'] = 'update';
        console.log(element.flag);
      });
    }
  }

}
